import Box from '@mui/material/Box';

export default function TabPanel({
    parentClass, selected, children, sx, ...rest
}) {
    return (
        <Box
            className={parentClass ? `${parentClass}_tabpanel` : 'tabpanel'}
            role="tabpanel"
            sx={[{
                overflow: 'auto',
                p: 3,
                display: selected ? 'flex' : 'none',
                flexDirection: 'column',
                height: '100%',
            }, sx]}
            {...rest}
        >
            {children}
        </Box>
    );
}
